import Helper from '@/utils/helper'
import store from '@/store/store'
import * as types from '@/store/types'

class AppInfoHelper {
  static updateVersion (version) {
    if (Helper.isDefined(version)) {
      if (!Helper.isDefined(store.state.info.version)) {
        store.dispatch(types.INFO.version.set, version)
      } else {
        if (version !== store.state.info.version) {
          location.reload()
        }
      }
    }
  }
}

export default AppInfoHelper
